import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { HTTPService, HelperService, ValidationService, DataService } from 'app/services';
import { config, messages } from 'app/constants';
import { ICustomer } from 'app/services/order';
import { customerSchema } from 'app/constants/schema';

import { UpdateContactDialogComponent } from '../update-contact-dialog/update-contact-dialog.component';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { CreateMyFleetCustomerDialogComponent } from '../create-myfleet-customer-dialog/create-myfleet-customer-dialog.component';

import { debounce, find, set, trim, xor } from 'lodash';
import { Subscription } from 'rxjs';
import { states } from 'app/constants/states';

@Component({
  selector: 'app-customer-update',
  templateUrl: './customer-update.component.html',
  styleUrls: ['./customer-update.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
})
export class CustomerUpdateComponent implements OnInit, OnDestroy {
  @Input('customerId')
  set customerId(customerId: any) {
    this.isFullNameQboUnique = true;
    this.errors = {};
    this.stateResults = {
      address: [],
      businessAddress: [],
    };
    this.addressResults = {
      address: [],
      businessAddress: [],
    };
    this.isCompatibilityBannerVisible = false;
    this.validate = {};
    this.getCustomerContacts();
  }
  @Input('highLightedCustomerNotes')
  set highLightedCustomerNotes(state: boolean) {
    if (state) {
      setTimeout(() => {
        try {
          const selectedEl = this.updateCustomerContainer.nativeElement.querySelector(`#Vcustomer-update-notes`) as HTMLElement;

          selectedEl.scrollIntoView({ block: 'start', inline: 'nearest' });
          selectedEl.focus();
        } catch (err) {}
      }, 1000);
    }
    this.isFullNameQboUnique = true;
    this.errors = {};
    this.validate = {};
  }
  @Input('openTaxExemptDropdown')
  set openTaxExemptDropdown(state: boolean) {
    if (state) {
      setTimeout(() => {
        try {
          const selectedEl = this.updateCustomerContainer.nativeElement.querySelector(`#Vcustomer-update-notes`) as HTMLElement;

          selectedEl.scrollIntoView({ block: 'start', inline: 'nearest' });
          this.isTaxDropdownFocused = true;
        } catch (err) {}
      }, 1000);
    }
    this.isFullNameQboUnique = true;
    this.errors = {};
    this.validate = {};
  }
  @Input('openPreferredLocation')
  set openPreferredLocation(state: boolean) {
    if (state) {
      setTimeout(() => {
        try {
          const selectedEl = this.updateCustomerContainer.nativeElement.querySelector(`#preferred-location`) as HTMLElement;

          selectedEl.scrollIntoView({ block: 'start', inline: 'nearest' });
          this.openPreferredLocation = true;
        } catch (err) {}
      }, 1000);
    }
    this.isFullNameQboUnique = true;
    this.errors = {};
    this.validate = {};
  }
  @Input('isFieldsMissing')
  set isFieldsMissing(isFieldsMissing: boolean) {
    if (isFieldsMissing) {
      this.isCompatibilityBannerVisible = true;
      setTimeout(() => {
        this.validation();
      }, 100);
    }
  }
  @Input() contactValidation: any = {};
  @Input() customer: ICustomer = customerSchema;
  @Input() estimate: any;
  @Input() appointments: any[] = [];
  @Input() vehicles: any[] = [];
  @Input() tags: any[] = [];
  @Input() qboTaxExemptReasons: any[] = [];
  @Input() isLoadingAppointment: boolean = false;
  @Input() isMarketingEnabled: boolean = false;
  @Input() roOpenAction: string = '';
  @Input() defaultCustomer: any = {};
  @Input() defaultCustomerChargeAccountState: boolean = false;
  @Input() index: number;
  @Input() isMyFleetCenterEnabled: boolean = false;
  @Input() companyLocalization: boolean = false;
  @Input() errors: any = {
    emails: {},
    phones: {},
    address: {
      addLine1: '',
      city: '',
      state: '',
      stateCode: '',
      zip: '',
      country: '',
    },
  };

  @Output() customerUpdate = new EventEmitter();
  @Output() customerDetails = new EventEmitter();
  @Output() updateModal = new EventEmitter();
  @Output() appUpdateCustomerTagList = new EventEmitter();
  @Output() setContactValidation = new EventEmitter();

  @ViewChild('updateCustomerContainer', { static: true })
  updateCustomerContainer: ElementRef;

  isTaxDropdownFocused: boolean = false;
  isFullNameQboUnique: boolean = true;
  isLandlineUnique: boolean = true;
  isZipCode1Valid: boolean = true;
  isZipCode2Valid: boolean = true;
  isMultiLocationEnabled: boolean = false;
  nameSuggestions: string[] = [];
  tagTypeCustomer: string = config.tags.customer;
  validate: any = {};
  focus = {
    notes: false,
  };
  addressCityResults: any;
  bAddressCityResults: any;
  addressCities = [];
  bAddressCities = [];
  allCities = [];
  customerTags: any[] = [];
  config = config;
  isCreateTagFieldVisible: boolean = false;
  isDataChange: boolean = false;
  customerAppointments: any;
  isDisplayNameChanged: boolean = false;
  isUnique = debounce(this._isUnique, 800);
  _populateCityByZipCode = debounce(this.populateCityByZipCode, 400);
  dataServiceSub: Subscription;
  isProcessing: boolean = false;
  isAppleDevice: boolean = false;
  contact: any = {};
  selectedLocation: any = {};
  customerTypes: any[] = [
    { label: 'Regular', value: 'regular' },
    { label: 'Fleet', value: 'fleet' },
  ];
  locationSuggestions: any[] = [];
  isPreferredLocationsEnabled: boolean = false;
  isDropdownOpen = false;
  closeAfterAction: boolean = false;
  currentLang: string = 'EN';
  customerMandatoryFields: any = this.dataService.customerMandatoryFields;
  countryOptions: any[] = [
    { name: 'Canada', value: 'Canada' },
    { name: 'USA', value: 'USA' },
  ];
  fieldsPlaceholder = {
    primaryAddress: {
      addLine1: 'Address 1',
      city: 'City',
      state: 'State/Province',
      zip: 'Zip/Postal code',
      country: 'Country',
    },
    secondaryAddress: {
      addLine1: 'Address 2',
      city: 'City',
      state: 'State/Province',
      zip: 'Zip/Postal code',
      country: 'Country',
    },
  };
  stateResults = {
    address: [],
    businessAddress: [],
  };
  addressResults = {
    address: [],
    businessAddress: [],
  };
  loader = {
    address: { addLine1: false, state: false },
    businessAddress: { addLine1: false, state: false },
  };
  isZipCodeLoading = {
    address: false,
    businessAddress: false,
  };
  isCompatibilityBannerVisible: boolean = false;
  isGoogleAddressSearchEnabled: boolean = false;

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private validationService: ValidationService,
    private dataService: DataService,
    private dialogService: DialogService,
  ) {}

  ngOnInit() {
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    this.setFeatureFlag();
    this.isAppleDevice = this.helperService.isAppleDevice();
    this.dataServiceSub = this.dataService.getData().subscribe((obj) => {
      if (obj.data.key === 'sidebar-customer-update') {
        this.onSubmit();
      }

      if (obj.data.key === 'check-validations') {
        if (this.customer._id) {
          this.customer = obj?.data?.data;
          this.validation();
        }
      }

      if (obj.data.key === 'update-customer-charge-account') {
        this.handleCustomerUpdate(true);
      }

      if (obj.data.key === 'company-appdata-updated') {
        this.isPreferredLocationsEnabled = this.dataService.isPreferredLocationsEnabled;
        this.setFeatureFlag();
      }
    });

    this.isMultiLocationEnabled = isMultiLocationEnabled;
    this.isPreferredLocationsEnabled = this.dataService.isPreferredLocationsEnabled;
  }

  ngOnDestroy() {
    if (this.dataServiceSub) {
      this.dataServiceSub.unsubscribe();
    }
  }

  setFeatureFlag() {
    this.customerMandatoryFields = this.dataService.customerMandatoryFields;
    this.isGoogleAddressSearchEnabled = this.dataService.isGoogleAddressSearchEnabled;
    this.fieldsPlaceholder.primaryAddress = {
      addLine1: `Address 1 ${this.customerMandatoryFields?.address ? ' *' : ''}`,
      city: `City ${this.customerMandatoryFields?.address ? ' *' : ''}`,
      state: `State/Province ${this.customerMandatoryFields?.address ? ' *' : ''}`,
      zip: `Zip/Postal code ${this.customerMandatoryFields?.address ? ' *' : ''}`,
      country: `Country ${this.customerMandatoryFields?.address ? ' *' : ''}`,
    };
  }

  handleChange(name: string, value: any, isNested = false) {
    /** Check for unique name */
    if (['firstName', 'lastName', 'fullNameQBO'].includes(name)) {
      const fullName = this.helperService.trimString(`${this.customer.firstName || ''} ${this.customer.lastName || ''}`);

      this.customer[name] = value;

      if (this.customer.fullNameQBO === fullName || !this.customer.fullNameQBO) {
        this.customer.fullNameQBO = this.helperService.trimString(`${this.customer.firstName || ''} ${this.customer.lastName || ''}`);
      }

      this.isCustomerNameUnique();
    }

    if (name === 'customerType' && value?.value) {
      this.customer.isFleetCustomer = value.value === 'fleet';

      if (this.customer.isFleetCustomer) {
        this.customer.firstName = this.customer.fullName;
        this.customer.firstName = this.customer.fullName;
        this.customer.lastName = '';
        this.customer.companyName = '';
        this.customer.chargeAccountEnable = true;
      } else {
        this.customer.firstName = this.defaultCustomer.firstName;
        this.customer.lastName = this.defaultCustomer.lastName;
        this.customer.companyName = this.defaultCustomer.companyName;
        this.customer.chargeAccountEnable = this.defaultCustomerChargeAccountState;
      }
    }

    if (name === 'phone' || name === 'phone2') {
      this.customer[name] = this.helperService.removePhoneFormatting(value);
    } else if (isNested) {
      const [prop, subProps] = name.split('.');
      this.customer[prop][subProps] = value;
    } else {
      this.customer[name] = value;
    }

    if (name === 'taxExemptReason') {
      this.validate.taxExemptReason = '';
    }

    if(name === 'address.zip') {
      this._populateCityByZipCode('address');
    } else if(name === 'businessAddress.zip') {
      this._populateCityByZipCode('businessAddress');
    }
  }

  handleFocus(name: string) {
    this.errors[name] = '';
    this.focus[name] = true;
    set(this.validate, name, '');

    if (name === 'address.state' && !this.stateResults?.address?.length) {
      this.handleStateSearch('', this.customer.address, 'address');
    } else if (name === 'businessAddress.state' && !this.stateResults?.businessAddress?.length) {
      this.handleStateSearch('', this.customer.businessAddress, 'businessAddress');
    }
  }

  handleBlur(name: string) {
    if (name === 'phone' && !this.customer.phone) {
      this.customer.contactOnPhone = false;
    } else if (name === 'email' && !this.customer.email) {
      this.customer.contactOnEmail = false;
    } else if (name === 'address' || name === 'businessAddress') {
      this.populateCityByZipCode(name);
    } else if (name === 'firstName' || name === 'lastName') {
      this.isCustomerNameUnique();
    }

    if (name === 'phone' || name === 'phone2') {
      if (!this.customer.phone || !this.customer.phone2) {
        this.errors.phone = '';
        this.errors.phone2 = '';
      }

      this.checkForDuplicateNumber();
    }
  }

  /** ********** City ********** */
  handleCitySelect(event: any, addressKey: string = 'address') {
    this.customer[addressKey].city = event.city;
    this.customer[addressKey].state = event.state;
    this.customer[addressKey].stateCode = event.stateCode;
    this.customer[addressKey].country = event.country;

    this.validate[addressKey].city = '';
    this.validate[addressKey].state = '';
    this.validate[addressKey].stateCode = '';
    this.validate[addressKey].country = '';
  }

  handleCityClear(addressType: string = 'address') {
    if (addressType === 'address') {
      this.addressCityResults = [];
      this.customer.address.city = null;
    } else {
      this.bAddressCityResults = [];
      this.customer.businessAddress.city = null;
    }
  }

  async handleCitySearch(event: string, address: any = {}, addressType: string = 'address') {
    const query = { city: this.helperService.trimString(event), stateCode: '', country: '' };

    if (address.country) query.country = address.country;
    if (address.stateCode) query.stateCode = address.stateCode;

    try {
      const cities: any = await this.httpService.citySearch(query);

      if (addressType === 'address') {
        this.addressCityResults = cities;
      } else {
        this.bAddressCityResults = cities;
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }

  handleTagDelete(deletedTag: any) {
    if (this.tags && this.tags.length) {
      this.tags = this.tags.filter(tag => {
        if (deletedTag._id) {
          return tag._id !== deletedTag._id;
        } else {
          return !(tag.name === deletedTag.name && tag.color === deletedTag.color);
        }
      });
    }
  }

  /** ********** Address ********** */
  handleAddressChange(value: string, addressKey: string = 'address') {
    this.customer[addressKey].addLine1 = value;
  }

  async handleAddressSelect(event: any, addressKey: string = 'address') {
    try {
      if (event.placeId) {
        let text = [];
        this.loader[addressKey].address = true;
        const addressDetails: any = await this.httpService.googleAddressDetails({ placeId: event.placeId });
        this.customer[addressKey] = { ...this.customer[addressKey], ...addressDetails };

        if (!addressDetails.streetNumber || !addressDetails.route || !addressDetails.city || !addressDetails.state || !addressDetails.zip) {
          // text.push('Address incomplete: Please add the missing');

          if (!addressDetails.streetNumber || !addressDetails.route) text.push('Street Number or Route');
          if (!addressDetails.zip) text.push('Zip Code');
          if (!addressDetails.city) text.push('City');
          if (!addressDetails.state) text.push('State');

          // text.push(`in Address Line ${addressKey === 'address' ? '1' : '2'}`);
          this.helperService.showToaster('error', ['Address incomplete: Please add the missing', text.join(', '), 'in Address'].join(' '));
        }
      }

      this.validation(addressKey);
    } catch (err) {
      console.log(err);
    } finally {
      this.loader[addressKey].address = false;
    }
  }

  handleAddressClear(addressType: string = 'address') {
    this.addressResults[addressType] = [];
  }

  async handleAddressSearch(event: string, address: any = {}, addressType: string = 'address') {
    const query = { search: this.helperService.trimString(event), country: '' };

    if (address.country) query.country = address.country;
    this.loader[addressType].addLine1 = true;
    try {
      const data: any = await this.httpService.googleAddressSearch(query);
      if (data?.length >= 0) this.addressResults[addressType] = data;
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.loader[addressType].addLine1 = false;
    }
  }

  /** ********** State/Province ********** */
  handleStateSelect(event: any, addressKey: string = 'address') {
    this.customer[addressKey].state = event.state;
    this.customer[addressKey].stateCode = event.stateCode;
    this.customer[addressKey].country = event.country === 'CA' ? 'Canada' : 'USA';

    this.validate[addressKey].state = '';
    this.validate[addressKey].stateCode = '';
    this.validate[addressKey].country = '';
  }

  handleStateClear(addressType: string = 'address') {
    this.stateResults[addressType] = [];
    this.customer[addressType].state = '';
    this.customer[addressType].stateCode = '';
  }

  async handleStateSearch(event: string, address: any = {}, addressType: string = 'address') {
    const query = { search: this.helperService.trimString(event), country: '' };

    if (address.country) query.country = address.country;
    this.loader[addressType].state = true;
    try {
      let data: any;
      if (address.city && !new RegExp('n/a', 'i').test(address.city)) {
        const query = { city: address.city, country: '' };

        if (address.country) query.country = address.country;

        data = await this.httpService.stateFilterByCity(query);
      } else {
        data = await this.httpService.stateSearch(query);
      }

      if (data?.states?.length >= 0) this.stateResults[addressType] = data.states;
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.loader[addressType].state = false;
    }
  }

  /** ********** Country ********** */
  handleCountrySelect(country: string, addressType: string = 'address') {
    if (this.customer[addressType].country && country !== this.customer[addressType].country) {
      if (addressType === 'address') {
        this.addressCityResults = [];
      } else {
        this.bAddressCityResults = [];
      }
      this.stateResults[addressType] = [];
      this.customer[addressType].zip = '';
      this.customer[addressType].city = '';
      this.customer[addressType].state = '';
      this.customer[addressType].stateCode = '';
    }

    this.customer[addressType].country = country;
    this.handleStateSearch('', this.customer[addressType], addressType);
  }

  onTagSelect(tag: any) {
    this.customer.tags.push({
      categoryId: tag._id,
      name: tag.name,
      color: tag.color,
    });
  }

  switchLanguage(lang: string) {
    this.currentLang = lang;
    this.customer.preferredLanguage = lang.toUpperCase();
  }

  onTagDelete(tags: any[]) {
    this.customer.tags = tags;
  }

  onTagCreate(tag: any) {
    this.tags = [...this.tags, tag];
  }

  updateCustomerTagList(tags: any[]) {
    this.tags = tags;
    this.appUpdateCustomerTagList.emit(this.tags);
  }

  populateCityByZipCode(type: string) {
    this.addressCities = this.allCities;
    this.bAddressCities = this.allCities;
    let zip = '';
    this.isZipCodeLoading[type] = true;
    if (type === 'address') {
      zip = this.customer.address.zip;
      this.customer.address.zip = this.validationService.formatZip(zip);
    } else {
      zip = this.customer.businessAddress.zip;
      this.customer.businessAddress.zip = this.validationService.formatZip(zip);
    }

    const formattedZip = this.helperService.removeSpaceFromString(zip).toUpperCase();

    this.httpService
      .getZip(formattedZip)
      .then(
        (res) => {
          if (res) {
            this.isZipCode1Valid = true;
            this.isZipCode2Valid = true;
            this.customer[type].city = res.city;
            this.customer[type].state = res.state;
            this.customer[type].stateCode = res.stateCode;
            this.customer[type].country = res.country;

            this.validate[type].city = '';
            this.validate[type].state = '';
            this.validate[type].stateCode = '';
            this.validate[type].country = '';
          } else {
            this.customer[type].city = null;
            this.customer[type].state = null;
            if (type === 'address') {
              this.errors.zip = 'Zip / Postal Code invalid';
              this.isZipCode1Valid = false;
            } else {
              this.errors.zip2 = 'Zip / Postal Code invalid';
              this.isZipCode2Valid = false;
            }
          }
        },
        (error) => {
          if (type === 'address') {
            this.isZipCode1Valid = false;
            this.errors.zip = 'Zip / Postal Code invalid';
          } else {
            this.isZipCode2Valid = false;
            this.errors.zip2 = 'Zip / Postal Code invalid';
          }
        },
      )
      .finally(() => {
        this.isZipCodeLoading[type] = false;
      });
  }

  onAddressCitySearch(query: string = '', type: string) {
    if (query) {
      this.httpService.citySearch({ city: this.helperService.trimString(query) }).then(
        (cities) => {
          if (type === 'primary') {
            this.addressCityResults = cities;
          } else {
            this.bAddressCityResults = cities;
          }
        },
        (error) => {
          this.helperService.showToaster('error', this.helperService.getErrorMsg(error));
        },
      );
    }
  }

  onAddressClear(name: string) {
    if (name === 'primary') {
      this.customer.address.city = '';
      this.bAddressCityResults = [];
    } else {
      this.addressCityResults = [];
      this.customer.businessAddress.city = '';
    }
  }

  onClearCity(type: string) {
    this.customer[type].city = '';
    this.customer[type].state = '';
    this.customer[type].zip = '';
    this.customer[type].country = '';
    this.customer[type].stateCode = '';
  }

  onAddressCitySelect(event: any, type: string) {
    this.customer[type].city = event.city;
    this.customer[type].state = event.state;
    this.customer[type].stateCode = event.stateCode;
    this.customer[type].country = event.country;
  }

  selectNameSuggestion(name: string) {
    this.customer.fullNameQBO = name;
    this.isFullNameQboUnique = true;
    this.errors.fullNameQBO = '';
    this._isUnique();
  }

  renderCityName(city: string, stateCode: string) {
    if (city && stateCode) {
      return `${city}, ${stateCode}`;
    }

    return `${city || ''}`;
  }

  isCustomerNameUnique() {
    if (this.customer.firstName && this.customer.lastName) {
      this.isUnique();
    }
  }

  _isUnique() {
    this.httpService.getCustomerIsUnique(`fullNameQBO=${this.customer.fullNameQBO}`, this.customer._id).then(
      ({ isUnique, suggestions = [], name }) => {
        if (name !== this.customer.fullNameQBO) {
          return;
        }

        if (isUnique) {
          this.isFullNameQboUnique = true;
        } else {
          this.nameSuggestions = suggestions;
          this.errors.fullNameQBO = 'Display name must be unique';
          this.isFullNameQboUnique = false;
        }
      },
      (err) => {},
    );
  }

  checkForDuplicateNumber() {
    if (this.customer.phone && this.customer.phone === this.customer.phone2) {
      this.errors.phone = 'Cell and Landline Number can not be the same';
      this.errors.phone2 = 'Cell and Landline Number can not be the same';
    }
  }

  validation(field: string = ''): Boolean {
    let isFormValid = true;
    this.isCompatibilityBannerVisible = false;
    this.validate = { address: {} };
    this.errors = {
      emails: {},
      phones: {},
      address: {
        addLine1: '',
        city: '',
        state: '',
        stateCode: '',
        zip: '',
        country: '',
      },
    };
    let hasScrollAlready = 0;

    if (this.isZipCodeLoading.businessAddress || this.isZipCodeLoading.address) return;

    if (!field) {
      if (this.dataService.customerMandatoryFields.email && !this.customer.email) {
        this.errors.email = '* Email Required';
        isFormValid = false;
        this.isCompatibilityBannerVisible = true;
      }

      if (this.dataService.customerMandatoryFields.mobile && !this.customer.phone) {
        this.errors.email = '* Phone Required';
        isFormValid = false;
        this.isCompatibilityBannerVisible = true;
      }

      if (!this.customer.firstName) {
        this.errors.firstName = '* First Name Required';
        isFormValid = false;
      }

      if (this.isMultiLocationEnabled && this.isPreferredLocationsEnabled && !this.customer?.preferredLocation?.name) {
        this.errors.preferredLocation = '*Preferred Location Required';
        isFormValid = false;
      }

      if (!this.customer.lastName && !this.customer.isFleetCustomer) {
        this.errors.lastName = '* Last Name Required';
        isFormValid = false;
      }

      if (!this.customer.fullNameQBO) {
        this.errors.fullNameQBO = '* Display Name Required';
        isFormValid = false;
      }

      if (this.customer.taxExempt && (!this.customer.taxExemptReason || (this.customer.taxExemptReason && !this.customer.taxExemptReason.qboId))) {
        this.validate.taxExemptReason = 'Reason for tax-exemption is required';
        isFormValid = false;
      }
    }

    if (field === 'address' || !field) {
      if (this.customerMandatoryFields?.address) {
        if (!trim(this.customer.address?.addLine1)) {
          this.validate.address.addLine1 = 'Please enter the Address.';
          isFormValid = false;
          this.isCompatibilityBannerVisible = true;
        }

        if (!trim(this.customer.address?.zip)) {
          this.validate.address.zip = 'Please enter the Zip Code.';
          isFormValid = false;
          this.isCompatibilityBannerVisible = true;
        }

        if (!trim(this.customer.address?.city)) {
          this.validate.address.city = 'Please select a City.';
          isFormValid = false;
          this.isCompatibilityBannerVisible = true;
        }

        if (!trim(this.customer.address?.state)) {
          this.validate.address.state = 'Please select a State/Province.';
          isFormValid = false;
          this.isCompatibilityBannerVisible = true;
        }

        if (!trim(this.customer.address?.country)) {
          this.validate.address.country = 'Please select a Country.';
          isFormValid = false;
          this.isCompatibilityBannerVisible = true;
        }

        if (this.customer.address.zip && !this.isZipCode1Valid) {
          this.errors.zip = 'Zip / Postal Code invalid';
          isFormValid = false;
        } else {
          this.isZipCode1Valid = true;
        }

        if (this.customer.businessAddress.zip && !this.isZipCode1Valid) {
          this.errors.zip = 'Zip / Postal Code invalid';
          isFormValid = false;
        } else {
          this.isZipCode2Valid = true;
        }
      } else {
        this.isZipCode1Valid = true;
        this.isZipCode2Valid = true;
      }
    }

    // const isValid = isFormValid && this.isZipCode1Valid && this.isZipCode2Valid && this.customer.firstName && this.customer.fullNameQBO && this.customer.lastName;

    if (!isFormValid) {
      this.scrollToTop(hasScrollAlready);
    }

    return isFormValid && this.isZipCode1Valid && this.isZipCode2Valid;
  }

  showCustomerTypeChangeConfirmation() {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '35%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        title: 'Update Customer type to Fleet',
        message: 'Once customer type is updated to Fleet, it cannot be reverted back to Regular. Are you sure you want to update?',
        button: {
          success: { title: 'Update' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        this.handleCustomerUpdate(true);
      }

      onClose.unsubscribe();
    });
  }

  handleCustomerUpdate(isForcedUpdate: boolean = false, isDisconnectedMyFleet: boolean = false) {
    if (this.isProcessing) {
      return;
    }
    this.isProcessing = true;
    const data = {
      _id: this.customer._id,
      companyName: this.customer.companyName,
      firstName: this.customer.firstName,
      lastName: this.customer.lastName,
      fullName: this.customer.fullName,
      fullNameQBO: this.customer.fullNameQBO,
      contactOnEmail: this.customer.contactOnEmail,
      email: this.customer.email,
      phone: this.customer.phone,
      contactOnPhone: this.customer.contactOnPhone,
      address: this.customer.address,
      businessAddress: this.customer.businessAddress,
      isActive: this.customer.isActive,
      chargeAccountEnable: this.customer.chargeAccountEnable,
      isFleetCustomer: this.customer.isFleetCustomer,
      notes: this.customer.notes,
      tags: this.customer.tags,
      taxExempt: this.customer.taxExempt,
      taxExemptReasonId: null,
      externalId: this.customer.externalId,
      preferredLocation: this.customer.preferredLocation,
      preferredLanguage: this.customer.preferredLanguage,
      isMFCustomer: this.customer.isMFCustomer,
      fleetNumber: this.customer.fleetNumber,
    };

    if (this.customer.taxExempt && this.customer.taxExemptReason && this.customer.taxExemptReason.qboId) {
      data.taxExemptReasonId = this.customer.taxExemptReason.qboId;
      this.customer.taxExemptReasonId = this.customer.taxExemptReason.qboId;
    }

    if (this.customer.isFleetCustomer && !this.defaultCustomer.isFleetCustomer && !isForcedUpdate) {
      this.isProcessing = false;
      this.showCustomerTypeChangeConfirmation();
      return;
    }

    if (this.customer.isFleetCustomer) {
      data.fullName = this.helperService.trimString(`${data.firstName} ${data.lastName}`);
      data.companyName = data.fullName;
    }

    this.httpService.updateCustomer(data).then(
      ({ customer, followUps = [] }) => {
        const hasTagsUpdated = xor((this.defaultCustomer.tags && this.defaultCustomer.tags.map(({ name }) => name)) || [], (customer.tags && customer.tags.map(({ name }) => name)) || []).length;

        if (hasTagsUpdated && followUps.length) {
          this.dataService.sendData(
            this.dataService.typeFollowUp('RO', {
              customer,
              event: 'customer_created',
              followUps: customer.followUps,
              customerId: customer._id,
            }),
          );
        }

        this.customerUpdate.emit(data);
        this.dataService.sendData(
          this.dataService.typeSidebar('close', null, null, {
            isSuccess: true,
            customer: data,
            type: 'customer',
            roOpenAction: this.roOpenAction,
          }),
        );

        if (this.roOpenAction) {
          this.dataService.sendData(
            this.dataService.typePassData('update-order-customer', {
              isSuccess: true,
              customer: customer,
              type: 'data',
              roOpenAction: this.roOpenAction,
            }),
          );
        }

        this.isProcessing = false;
        let message = messages.customerSaved;
        if (isDisconnectedMyFleet) {
          message = messages.myFleetCustomerDisconnected;
        }
        this.helperService.showToaster('success', message);
      },
      (err) => {
        this.isProcessing = false;
        this.helperService.showToaster('error', err);
      },
    );
  }

  onSubmit() {
    if (this.validation()) {
      this.handleCustomerUpdate();
    }
  }

  openContactUpdateDialog() {
    const ref = this.dialogService.open(UpdateContactDialogComponent, {
      closeOnEscape: false,
      width: '650px',
      styleClass: 'add-dialog add-receipt-modal update-contact-dialog',
      showHeader: false,
      data: {
        contactEntityId: this.customer._id,
        email: this.customer.email,
        phone: this.customer.phone,
        isFleetCustomer: this.customer.isFleetCustomer,
        contact: this.contact,
        isMFCustomer: this.customer.isMFCustomer,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        this.customerUpdate.emit({
          ...data.customer,
          updateContactOnly: true,
        });
        this.setContactValidation.emit();
        this.getCustomerContacts();
      }
      onClose.unsubscribe();
    });
  }

  scrollToTop(scrollHeight: any) {
    setTimeout(() => {
      try {
        this.updateCustomerContainer.nativeElement.scrollTop = scrollHeight;
      } catch (err) {}
    }, 100);
  }

  scrollToBottom() {
    setTimeout(() => {
      try {
        this.updateCustomerContainer.nativeElement.scrollTop = this.updateCustomerContainer.nativeElement.scrollHeight + 18;
      } catch (err) {}
    }, 100);
  }

  getCustomerContacts() {
    if (!this.customer._id) return;

    this.httpService.getContactInfo(this.customer._id, false, { contactEntityType: 'customer' }).then(
      (contact) => {
        this.contact = contact;
        this.customerDetails.emit({
          contact,
        });
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onLocationSearch(query: string) {
    this.httpService
      .getShopLists({ query })
      .then((response) => {
        if (response && response.records && Array.isArray(response.records)) {
          this.locationSuggestions = response.records.map((location) => ({
            _id: location._id,
            address: location.address,
            name: location.name,
          }));
          this.searchLocation(query);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  showSuggestions(e: any) {
    if (e === 'pLocation') {
      this.httpService
        .getShopLists({})
        .then((response) => {
          if (response && response.records && Array.isArray(response.records)) {
            this.locationSuggestions = response.records.map((location) => ({
              _id: location._id,
              address: location.address,
              name: location.name,
            }));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  searchLocation(query: string) {
    this.locationSuggestions = this.locationSuggestions.filter((loc) => {
      return new RegExp(`${query}`, 'gi').test(loc.name);
    });
  }

  onLocationSelect(event: any) {
    if (this.customer) {
      this.customer.preferredLocation = {
        name: event.name,
        locationId: event._id,
      };
      this.errors.preferredLocation = '';
    }
  }

  onLocationClear() {
    this.locationSuggestions = [];
    if (this.customer) {
      this.customer.preferredLocation = { name: '', locationId: '' };
    }
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  onChangeFleetConnection(type?) {
    this.closeAfterAction = !this.closeAfterAction;
    if (type === 'disconnect') {
      this.customer.isMFCustomer = false;
      this.handleCustomerUpdate(false, true);
    } else {
      this.handleOpenFleetCustomer();
    }
  }

  handleOpenFleetCustomer() {
    const ref = this.dialogService.open(CreateMyFleetCustomerDialogComponent, {
      styleClass: 'add-dialog item-dialog new-part',
      showHeader: false,
      data: {
        fleetName: this.customer.firstName,
        fleetNumber: this.customer.fleetNumber,
        isHideVehicle: true,
        customer: this.customer,
        openFrom: 'customer-update',
      },
    });
    const onClose = ref.onClose.subscribe((response: any) => {
      if (response.fleetNumber) {
        // Clear phone and email fields before updating customer object
        this.customer.phone = '';
        this.customer.email = '';

        // Update customer object and set openFromMFC flag to true
        this.customer = {
          ...this.customer,
          ...response,
          openFromMFC: true,
        };

        // Send updated data for sidebar and default customer updates
        this.dataService.sendData(this.dataService.typePassData('sidebar-vehicle-update', { customer: this.customer }));
        this.dataService.sendData(this.dataService.typePassData('default-customer-update', { customer: this.customer }));

        // Send customer data for estimate
        this.dataService.sendData(
          this.dataService.typePassData('customer-for-estimate', {
            _id: this.customer._id,
            fullName: this.customer.fullName,
            email: this.customer.email,
            phone: this.customer.phone,
            customer: this.customer,
          }),
        );

        // Schedule a delayed update for resetting openFromMFC flag
        setTimeout(() => {
          this.customer.openFromMFC = false;
          this.getCustomerContacts();
        }, 1000);
      }
      // Unsubscribe from onClose event
      onClose.unsubscribe();
    });
  }

  isValidMyFleetConnected() {
    if (this.customer.isMFCustomer && this.isMyFleetCenterEnabled) {
      return true;
    }
    return false;
  }
}
